import React, { Component } from 'react'
import { FacebookShareButton, TwitterShareButton, PinterestShareButton } from 'react-share'
import Icon from '../misc/Icons'
import { getImageUrl } from '../../utils/mediaDeliveryUrls'

class AuthorSocialMediaShareRow extends Component {
  render() {
    const { author } = this.props
    const authorShareURL = `${process.env.REACT_APP_URL}/${author.username}`

    const imageURL = author.image ?
      getImageUrl(author.id, { version: author.image, folderPath: '/profile', transformations: 'c_fill,h_128,w_128' }) :
      'https://assets.plickers.com/brand-assets/PlickersLogo640.png'

    return (
      <div className='repoSocialMediaShareRow'>
        <FacebookShareButton
          url={authorShareURL}
          hashtag='#plickers'
        >
          <div className='repoSocialMediaShareRow-item repoSocialMediaShareRow-item--facebook'>
            <Icon name='social-media-facebook-share' />
            Share
          </div>
        </FacebookShareButton>

        <TwitterShareButton
          url={authorShareURL}
          title={`${author.username} - Plickers`}
          hashtags={['plickers']}
        >
          <div className='repoSocialMediaShareRow-item repoSocialMediaShareRow-item--twitter'>
            <Icon name='social-media-twitter-tweet' />
            Tweet
          </div>
        </TwitterShareButton>

        <PinterestShareButton
          url={String(authorShareURL)}
          media={String(imageURL)}
          description={author.description ? author.description : null}
        >
          <div className='repoSocialMediaShareRow-item repoSocialMediaShareRow-item--pinterest'>
            <Icon name='social-media-pinterest-save' />
            Save
          </div>
        </PinterestShareButton>
      </div>
    )
  }
}

export default AuthorSocialMediaShareRow
